<script lang="ts" setup>
import type { Field } from '~~/server/api/forms/form'

interface PagebuilderFormProps {
    data: {
        form: {
            id: number
            fields: Field[]
        }
    }
}

const props = defineProps<PagebuilderFormProps>()
</script>

<template>
  <FormKitWrapper
    :form-id="`${props.data.form.id}`"
    :fields="props.data.form.fields"
    class="mb-15"
  />
</template>